// @ts-nocheck
import { WEB_IN_APP_EVENT } from 'shared/constants/common';

function iosPostMessageHandler(event: WEB_IN_APP_EVENT) {
  try {
    (window as any).webkit.messageHandlers.requestAction.postMessage(event);
  } catch (error) {
    console.warn(`IOSPostMessageHandler with event "${event}" error`, error);
  }
}

function androidPostMessageHandler(name: WEB_IN_APP_EVENT) {
  try {
    WebJSInterface.requestAction(JSON.stringify({ name }));
  } catch (error) {
    console.warn(`AndroidPostMessageHandler with event "${name}" error`, error);
  }
}

export function postMessage(event: WEB_IN_APP_EVENT) {
  if ((window as any).webkit) {
    iosPostMessageHandler(event);
    console.log('IOSPostMessageHandler', event);
  } else if (typeof WebJSInterface !== 'undefined') {
    androidPostMessageHandler(event);
    console.log('AndroidPostMessageHandler', event);
  } else {
    console.log('Not found device type to emit event');
  }
}
